
















































import Vue from 'vue';
import EmojiBox from 'common/components/ui/Emoji/index.vue';
import LinkInsertBox from 'common/components/ui/LinkInsertBox/index.vue';
import { Emoji } from '@/common/components/ui/Emoji/emojis';

export default Vue.extend({
  components: {
    EmojiBox,
    LinkInsertBox,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showEmojiBox: false,
      showLinkInsertBox: false,
      showRichTextBox: false,
      content: '',
    };
  },
  methods: {
    confirmInput() {
      if (this.content.length === 0) {
        this.$Message.error('请填写内容');
      } else {
        this.$emit('confirm', this.content);
      }
    },
    addLink(val: any) {
      const linkHtml = '[' + val.text + '](' + val.link + ')';
      const tmpStr = this.content;
      const $el = this.$el.querySelector('#contentInfo');
      const cursorPos = this.getCursortPosition($el);
      this.content = tmpStr.substring(0, cursorPos) + linkHtml + tmpStr.substring(cursorPos, tmpStr.length);
      this.$nextTick(() => {
        ($el! as HTMLInputElement).selectionStart = cursorPos + linkHtml.length;
      });
      this.showLinkInsertBox = false;
    },
    insertEmoji(emoji: Emoji) {
      const name = '[' + emoji.name + ']';
      const tmpStr = this.content;
      const $el = this.$el.querySelector('#contentInfo');
      const cursorPos = this.getCursortPosition($el);
      this.content = tmpStr.substring(0, cursorPos) + name + tmpStr.substring(cursorPos, tmpStr.length);
      this.$nextTick(() => {
        ($el! as HTMLInputElement).selectionStart = cursorPos + name.length;
      });
      this.showEmojiBox = false;
    },
    getCursortPosition($el: any) {
      let cursorPos = 0;
      if ((document as any).selection) {
        $el.focus();
        const sel: any = (document as any).selection.addRange();
        sel.moveStart('character', -$el.value.length);
        cursorPos = sel.text.length;
      } else if ($el.selectionStart >= 0) {
        cursorPos = $el.selectionStart;
      }
      return cursorPos;
    },
    close() {
      this.$emit('close');
    },
  },
  watch: {
    show() {
      this.showRichTextBox = this.show;
    },
  },
  mounted() {
    this.content = this.text;
  },
});
